/**
 * Created by zhangsanfeng on 2020/5/21.
 */

export const mock = {
  //甲板
  deck: [
    {name: '甲板1', num: '1号', id: 1},
    {name: '甲板2', num: '2号', id: 2},
  ],

  //区域
  area: [
    {id: 1, name: '特殊区域1', type: 'special', deck: '甲板1', points: []},
    {
      id: 2,
      name: '特殊区域2（有模拟数据）',
      type: 'special',
      deck: '甲板1',
      points: [
        {x: 1493, y: 471},
        {x: 2227, y: 561},
        {x: 2484, y: 1048},
        {x: 1816, y: 1188},
        {x: 1201, y: 885}
      ]
    },
    {id: 3, name: '特殊区域3', type: 'special', deck: '甲板1', points: []},
    {id: 4, name: '特殊区域4', type: 'special', deck: '甲板1', points: []},
    {id: 5, name: '特殊区域5', type: 'special', deck: '甲板1', points: []},
    {id: 6, name: '普通区域1', type: 'common', deck: '甲板1', points: []},
    {id: 7, name: '普通区域2', type: 'common', deck: '甲板2', points: []},
    {id: 8, name: '普通区域3', type: 'common', deck: '甲板1', points: []},
    {id: 9, name: '普通区域4', type: 'common', deck: '甲板1', points: []},
    {id: 10, name: '普通区域5', type: 'common', deck: '甲板1', points: []},
  ],

  //过道
  passage: [
    {
      id: 1,
      name: '过道1',
      direction: 'horizontal',
      left_up_through: false,
      left_up_point: {x: 0, y: 0},
      right_bottom_through: true,
      right_bottom_point: {x: 1860, y: 381},
      deck_id: 1,  //deck: '甲板1',
    },
    {
      id: 2,
      name: '过道2',
      direction: 'horizontal',
      left_up_through: true,
      left_up_point: {x: 1962, y: 537},
      right_bottom_through: false,
      right_bottom_point: {x: 0, y: 0},
      deck_id: 1,      //deck: '甲板1',
    },
    {
      id: 3,
      name: '过道3',
      direction: 'vertical',
      deck_id: 1,   //deck: '甲板1',
      left_up_through: true,
      left_up_point: {x: 1865, y: 424},
      right_bottom_through: false,
      right_bottom_point: {x: 0, y: 0}
    },
    {
      id: 4,
      name: '过道4',
      direction: 'horizontal',
      left_up_through: false,
      left_up_point: {x: 0, y: 0},
      right_bottom_through: true,
      right_bottom_point: {x: 3965, y: 585},
      deck_id: 2,  //deck: '甲板2',
    },
    {
      id: 5,
      name: '过道5',
      direction: 'horizontal',
      left_up_through: true,
      left_up_point: {x: 4035, y: 580},
      right_bottom_through: false,
      right_bottom_point: {x: 0, y: 0},
      deck_id: 2, //deck: '甲板2',
    },
  ],

  //同甲板连接过道
  deck_connect_passage: [
    {
      deck_id: 2,
      connect: [
        {
          deck_id: 2,
          passage1_name: '过道4',
          passage1_id: 4,
          passage1_point: 'right_bottom',
          passage2_name: '过道5',
          passage2_id: 5,
          passage2_point: 'left_up',
        },
      ]
    },
    {
      deck_id: 1,
      connect: [
        {
          deck_id: 1,
          passage1_name: '过道1',
          passage1_id: 1,
          passage1_point: 'right_bottom',
          passage2_name: '过道2',
          passage2_id: 2,
          passage2_point: 'left_up',
        },
        {
          deck_id: 1,
          passage1_name: '过道1',
          passage1_id: 1,
          passage1_point: 'right_bottom',
          passage2_name: '过道3',
          passage2_id: 3,
          passage2_point: 'left_up',
        },
        {
          deck_id: 1,
          passage1_name: '过道2',
          passage1_id: 2,
          passage1_point: 'left_up',
          passage2_name: '过道3',
          passage2_id: 3,
          passage2_point: 'left_up',
        },
      ]
    }
  ],

  //楼梯
  stair: [
    {
      id: 1,
      name: '楼梯1',
      deck1: {name: '甲板1', id: 1},
      passage1: {name: '过道1', id: 1},
      point1: {x: 1569, y: 489},
      deck2: {name: '甲板2', id: 2},
      passage2: {name: '过道4', id: 4},
      point2: {x: 3622, y: 508},
    },
    {
      id: 2,
      name: '楼梯2',
      deck1: {name: '甲板1', id: 1},
      passage1: {name: '过道2', id: 2},
      point1: {x: 2043, y: 490},
      deck2: {name: '甲板2', id: 2},
      passage2: {name: '过道5', id: 5},
      point2: {x: 4179, y: 520},
    }
  ],

  //基站
  station: [
    {
      id: 1,
      name: '基站1',
      deck_id: 1,   //deck_name: '甲板1',
      passage_id: 1,   //passage_name: '过道1',
      points: [{x: 570, y: 359}]  //默认[{x:0,y:0}]
    },
    {
      id: 2,
      name: '基站2',
      deck_id: 1,   //deck_name: '甲板1',
      passage_id: 1,   //passage_name: '过道1',
      points: [{x: 1572, y: 455}, {x: 1570, y: 358}]
    },
    {
      id: 3,
      name: '基站3',
      deck_id: 1,   //deck_name: '甲板1',
      passage_id: 3,   //passage_name: '过道3',
      points: [{x: 1612, y: 706}, {x: 1863, y: 704}]
    },
    {
      id: 4,
      name: '基站4',
      deck_id: 1,   //deck_name: '甲板1',
      passage_id: 3,   //passage_name: '过道3',
      points: [{x: 1594, y: 1002}, {x: 1864, y: 1019}]
    },
    {
      id: 5,
      name: '基站5',
      deck_id: 1,   //deck_name: '甲板1',
      passage_id: 2,   //passage_name: '过道2',
      points: [{x: 1945, y: 459}, {x: 1957, y: 536}]
    },
    {
      id: 6,
      name: '基站6',
      deck_id: 1,   //deck_name: '甲板1',
      passage_id: 2,   //passage_name: '过道2',
      points: [{x: 2473, y: 540}, {x: 2451, y: 560}]
    },
    {
      id: 7,
      name: '基站7',
      deck_id: 1,   //deck_name: '甲板1',
      passage_id: 2,   //passage_name: '过道2',
      points: [{x: 2476, y: 303}, {x: 2173, y: 358}, {x: 2023, y: 435}, {x: 2038, y: 550}]
    },
    {
      id: 8,
      name: '基站8',
      deck_id: 1,   //deck_name: '甲板1',
      passage_id: 2,   //passage_name: '过道2',
      points: [{x: 2702, y: 302}, {x: 2606, y: 392}, {x: 2628, y: 552}]
    },
    {
      id: 9,
      name: '基站9',
      deck_id: 2,   //deck_name: '甲板2',
      passage_id: 4,   //passage_name: '过道4',
      points: [{x: 3166, y: 313}, {x: 3264, y: 421}, {x: 3259, y: 574}]
    },
    {
      id: 10,
      name: '基站10',
      deck_id: 2,   //deck_name: '甲板2',
      passage_id: 4,   //passage_name: '过道4',
      points: [{x: 3166, y: 577}]
    },
    {
      id: 11,
      name: '基站11',
      deck_id: 2,   //deck_name: '甲板2',
      passage_id: 4,   //passage_name: '过道4',
      points: [{x: 3934, y: 580}]
    },
    {
      id: 12,
      name: '基站12',
      deck_id: 2,   //deck_name: '甲板2',
      passage_id: 4,   //passage_name: '过道4',
      points: [{x: 3969, y: 323}, {x: 3894, y: 569}]
    },
    {
      id: 13,
      name: '基站13',
      deck_id: 2,   //deck_name: '甲板2',
      passage_id: 5,   //passage_name: '过道5',
      points: [{x: 4132, y: 316}, {x: 4079, y: 578}]
    },
    {
      id: 14,
      name: '基站14',
      deck_id: 2,   //deck_name: '甲板2',
      passage_id: 5,   //passage_name: '过道5',
      points: [{x: 4489, y: 439}, {x: 4384, y: 557}, {x: 4399, y: 589}]
    },
    {
      id: 15,
      name: '基站15',
      deck_id: 2,   //deck_name: '甲板2',
      passage_id: 5,   //passage_name: '过道5',
      points: [{x: 4674, y: 589}]
    },
  ],

  //模拟路径
  temp_path: [
    {
      user: {id: 1, name: '张1丰'},
      paths: [
        {
          station_id: 1, station_name: '基站1',
          station_points: [{x: 570, y: 359}], passage_id: 1, deck_id: 1,
          millisecond: 1589617035000, type: 'in'
        },
        {
          station_id: 1, station_name: '基站1', station_points: [{x: 570, y: 359}],
          passage_id: 1, deck_id: 1,
          millisecond: 1589617036000, type: 'out'
        },
        {
          station_id: 2,
          station_name: '基站2',
          station_points: [{x: 1572, y: 455}, {x: 1570, y: 358}],
          passage_id: 1,
          deck_id: 1,
          millisecond: 1589617038000,
          type: 'in'
        },
        {
          station_id: 2,
          station_name: '基站2',
          station_points: [{x: 1572, y: 455}, {x: 1570, y: 358}],
          passage_id: 1,
          deck_id: 1,
          millisecond: 1589617040000,
          type: 'out'
        },
        {
          station_id: 3,
          station_name: '基站3',
          station_points: [{x: 1612, y: 706}, {x: 1863, y: 704}],
          passage_id: 3,
          deck_id: 1,
          millisecond: 1589617041000,
          type: 'in'
        },
        {
          station_id: 3,
          station_name: '基站3',
          station_points: [{x: 1612, y: 706}, {x: 1863, y: 704}],
          passage_id: 3,
          deck_id: 1,
          millisecond: 1589617042000,
          type: 'out'
        },
      ]
    },
    {
      user: {id: 2, name: '张2丰'},
      paths: [
        {
          station_id: 4,
          station_name: '基站4',
          station_points: [{x: 1594, y: 1002}, {x: 1864, y: 1019}],
          passage_id: 3,
          deck_id: 1,
          millisecond: 1589617044000,
          type: 'in'
        },
        {
          station_id: 4,
          station_name: '基站4',
          station_points: [{x: 1594, y: 1002}, {x: 1864, y: 1019}],
          passage_id: 3,
          deck_id: 1,
          millisecond: 1589617045000,
          type: 'out'
        },
        {
          station_id: 5,
          station_name: '基站5',
          station_points: [{x: 1945, y: 459}, {x: 1957, y: 536}],
          passage_id: 2,
          deck_id: 1,
          millisecond: 1589617047000,
          type: 'in'
        },
        {
          station_id: 5,
          station_name: '基站5',
          station_points: [{x: 1945, y: 459}, {x: 1957, y: 536}],
          passage_id: 2,
          deck_id: 1,
          millisecond: 1589617052000,
          type: 'out'
        },
        {
          station_id: 13,
          station_name: '基站13',
          station_points: [{x: 4132, y: 316}, {x: 4079, y: 578}],
          passage_id: 5,
          deck_id: 2,
          millisecond: 1589617057000,
          type: 'in'
        },
        {
          station_id: 13,
          station_name: '基站13',
          station_points: [{x: 4132, y: 316}, {x: 4079, y: 578}],
          passage_id: 5,
          deck_id: 2,
          millisecond: 1589617062000,
          type: 'out'
        },
        {
          station_id: 8,
          station_name: '基站8',
          station_points: [{x: 2702, y: 302}, {x: 2606, y: 392}, {x: 2628, y: 552}],
          passage_id: 2,
          deck_id: 1,
          millisecond: 1589617067000,
          type: 'in'
        },
        {
          station_id: 8,
          station_name: '基站8',
          station_points: [{x: 2702, y: 302}, {x: 2606, y: 392}, {x: 2628, y: 552}],
          passage_id: 2,
          deck_id: 1,
          millisecond: 1589617072000,
          type: 'out'
        },
      ]
    },
    {
      user: {id: 3, name: '张3丰'},
      paths: [
        {
          station_id: 9,
          station_name: '基站9',
          station_points: [{x: 3166, y: 313}, {x: 3264, y: 421}, {x: 3259, y: 574}],
          passage_id: 4,
          deck_id: 2,
          millisecond: 1589617024000,
          type: 'in'
        },
        {
          station_id: 9,
          station_name: '基站9',
          station_points: [{x: 3166, y: 313}, {x: 3264, y: 421}, {x: 3259, y: 574}],
          passage_id: 4,
          deck_id: 2,
          millisecond: 1589617027000,
          type: 'out'
        },
        {
          station_id: 4,
          station_name: '基站4',
          station_points: [{x: 1594, y: 1002}, {x: 1864, y: 1019}],
          passage_id: 3,
          deck_id: 1,
          millisecond: 1589617037000,
          type: 'in'
        },
        {
          station_id: 4,
          station_name: '基站4',
          station_points: [{x: 1594, y: 1002}, {x: 1864, y: 1019}],
          passage_id: 3,
          deck_id: 1,
          millisecond: 1589617047000,
          type: 'out'
        },
        {
          station_id: 13,
          station_name: '基站13',
          station_points: [{x: 4132, y: 316}, {x: 4079, y: 578}],
          passage_id: 5,
          deck_id: 2,
          millisecond: 1589617057000,
          type: 'in'
        },
        {
          station_id: 13,
          station_name: '基站13',
          station_points: [{x: 4132, y: 316}, {x: 4079, y: 578}],
          passage_id: 5,
          deck_id: 2,
          millisecond: 1589617067000,
          type: 'out'
        },
      ]
    }
  ]
};
